module.exports = __webpack_public_path__ + "img/cloud.8c54d504.webp";